import jsPDF from "jspdf";
import { vatRateOnDate, vatRateStringOnDate } from '@/utils';
import { DateTime } from "luxon";
import fonts from "../../assets/fonts/fonts.js";
import images from "../../assets/oferta_images.js";
import router from "../../router/index.js";
import { replaceSpecialCh, formatPhoneNo, dimTextString } from '@/utils';


export const pdf_proforma_materie_prima = {
  createProformaMateriePrimaPDF(proforma) {
    return new Promise(resolve => {
      try {
        const doc = new jsPDF({
          orientation: "p",
          unit: "mm",
          format: "a4"
        });

        const logo = images.data.logo
		const vatRate = vatRateOnDate(proforma.data)

		const products_no_proforma = proforma.produse_obj.length + proforma.custom_obj.length

		const printProduct = (produs) => {
			let detalii = produs.detalii;

			if (detalii != undefined && detalii != "") {
				detalii = " - " + detalii;
			} else {
				detalii = "";
			}

			let dim = dimTextString(produs);
			if (dim == "") {
				dim = produs.dimensiune;
			}

			// For old offers that do not have 'denumire' in object format
			let denumire = "";
			if (produs.denumire.value) {
				denumire = `${produs.denumire.value} ${produs.material}${detalii}, ${dim}, aliaj: ${produs.aliaj}`;
			} else {
				denumire = `${produs.denumire} ${produs.material}${detalii}, ${produs.dimensiune}, aliaj: ${produs.aliaj}`;
			}

			if (denumire.length > 70) {
				denumire = doc.splitTextToSize(denumire, 100);
			}

			doc.text(String(produs.nr), 11, space);
			doc.text(denumire, 18, space);

			doc.text(produs.cantitate + " " + produs.um, 122, space, {
				align: "left",
			});
			doc.text("(" + produs.greutate + " kg)", 122, space + 4, {
				align: "left",
			});
			let pret_unitar = (produs.pret_u * curs).toFixed(2);
			let valoare = (pret_unitar * produs.cantitate).toFixed(2);
			doc.text(pret_unitar + " ron/" + produs.um, 170, space, {
				align: "right",
			});
			doc.text(valoare + " ron", 199, space, {
				align: "right",
			});

			total_fara_tva = total_fara_tva + Number(valoare);

			space = space + 3;
		};

        //add the font to jsPDF
        doc.addFileToVFS("Roboto-Regular.ttf", fonts.robotoRegular);
        doc.addFileToVFS("Roboto-Bold.ttf", fonts.robotoBold);
        doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
        doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");

        // set font
        doc.setFont("Roboto", "normal");
        doc.setTextColor(100);

        // Add Logo
		doc.addImage(logo, "JPEG", 10, 9, 27, 12);

        // Header - Left side
        doc.setFont("Roboto", "bold");
        doc.setFontSize(10);
        doc.text("Cuprolli Manufacturing srl", 10, 30);
        doc.setFontSize(9);
        doc.setFont("Roboto", "normal");
        doc.text(["CUI/CIF: RO 35671874", "RC: J2016000468359"], 10, 35, {
			lineHeightFactor: 1.25,
		});
        doc.text(
			["Strada Caprioarei nr.11", "307200 Ghiroda, jud. Timis"],
			10,
			43
		);
        doc.setFont("Roboto", "bold");
        doc.text(
			["Banca: Banca Transilvania", "IBAN: RO42 BTRL RONC RT03 3757 8301"],
			10,
			53
		);

		doc.setFont("Roboto", "normal");
		doc.text(
			[
				"Dl/Dna: " + proforma.username,
				"Email: " + proforma.email_user,
				"Tel: " + proforma.tel_user,
			],
			10,
			62,
			{
				lineHeightFactor: 1.35,
			}
		);
		doc.setFont("Roboto", "bold");
		doc.text(`Cota TVA: ${vatRateStringOnDate(proforma.data)}`, 10, 78);
		doc.setFont("Roboto", "normal");

        //
		// Header - Right side
		let data = DateTime.fromISO(String(proforma.data)).toFormat('dd.MM.yyyy');
		doc.setFontSize(16);
		doc.setTextColor(243, 153, 46);
		doc.text("FACTURA  PROFORMA", 130, 15);
		doc.setFontSize(9);
		doc.setTextColor(100);
		doc.text("Nr: " + proforma.id_proforma + " / " + data, 130, 20);

		// Client data
		doc.setFont("Roboto", "bold");
		doc.setFontSize(10);
		doc.text("Client", 130, 30);
		doc.setFontSize(9);
		doc.setFont("Roboto", "normal");
		let nume = replaceSpecialCh(proforma.nume);
		let drop = 35;
		let numeSplit = doc.splitTextToSize(nume, 62);
		doc.text(numeSplit, 130, drop, {
			lineHeightFactor: 1.35,
		});
		if (nume.length <= 38) {
			drop = drop + 5;
		} else {
			drop = drop + 9;
		}

		if (proforma.cui) {
			doc.text("CUI/CIF: " + proforma.cui, 130, drop);
			drop = drop + 4;
		}

		if (proforma.adresa) {
			let adresa = replaceSpecialCh(proforma.adresa);
			if (proforma.oras) {
				adresa += ", " + replaceSpecialCh(proforma.oras);
			}
			let adresaSplit = doc.splitTextToSize(adresa, 62);
			doc.text(adresaSplit, 130, drop);
			if (adresa.length != 0 && adresa.length <= 44) {
				drop = drop + 4;
			} else if (adresa.length != 0 && adresa.length <= 73) {
				drop = drop + 8;
			} else if (adresa.length != 0) {
				drop = drop + 12;
			}
		}

		drop = drop + 1;

      	let details = [];
		if (proforma.persoana) {
			details.push("Dl/Dna: " + proforma.persoana);
		}
		if (proforma.email) {
			details.push("Email: " + proforma.email);
		}
		if (proforma.tel && proforma.tel != "-") {
			details.push("Tel: " + formatPhoneNo(proforma.tel));
		}
		doc.text(details, 130, drop, {
			lineHeightFactor: 1.35,
		});

		//
		// Products table print
		let curs = proforma.moneda == "ron" ? 1 : proforma.curs;
		let total_fara_tva = 0;
		const PAGE_BREAK_THRESHOLD = 220;

		const printTableHeader = (y) => {
			doc.setFont("Roboto", "bold");
			doc.text("Nr.", 10, y);
			doc.text("Denumire produs", 18, y);
			doc.text("Cantitate", 122, y, { align: "left" });
			doc.text("Pret unitar", 170, y, { align: "right" });
			doc.text("Valoare fara TVA", 200, y, { align: "right" });
			doc.setDrawColor(150);
			doc.setLineWidth(0.4);
			doc.line(10, y + 2, 200, y + 2);
			doc.setFont("Roboto", "normal");
		};

		// Table header
		printTableHeader(86);
		let space = 93;

		// Print products
		for (let i = 0; i < proforma.produse_obj.length; i++) {
			printProduct(proforma.produse_obj[i]);
			doc.setLineWidth(0.2);
			doc.line(10, space + 3, 200, space + 3);
			space = space + 8;

			const hasMore = i < proforma.produse_obj.length - 1 || proforma.custom_obj.length > 0;
			if (hasMore && space > PAGE_BREAK_THRESHOLD) {
				doc.addPage();
				doc.setTextColor(100);
				space = 20;
				printTableHeader(space);
				space = space + 7;
			}
		}

		for (let i = 0; i < proforma.custom_obj.length; i++) {
			const produs = proforma.custom_obj[i];
			doc.text(String(produs.nr), 11, space);
			let dimensiune_text = produs.dimensiune_text ? " - " + produs.dimensiune_text : "";
			let denumire = `${produs.denumire}${dimensiune_text}`;

			if (denumire.length > 70) {
				denumire = doc.splitTextToSize(denumire, 100);
				doc.text(denumire, 18, space);
				space = space + 4;
			} else {
				doc.text(denumire, 18, space);
			}

			let pret_unitar = (produs.pret_u * curs).toFixed(2);
			let valoare = (pret_unitar * produs.cantitate).toFixed(2);
			doc.text(produs.cantitate + " " + produs.um, 122, space, {
				align: "left",
			});
			doc.text(pret_unitar + " ron", 170, space, {
				align: "right",
			});
			doc.text(valoare + " ron", 199, space, {
				align: "right",
			});
			total_fara_tva = total_fara_tva + Number(valoare);
			doc.line(10, space + 3, 200, space + 3);
			space = space + 8;

			if (i < proforma.custom_obj.length - 1 && space > PAGE_BREAK_THRESHOLD) {
				doc.addPage();
				doc.setTextColor(100);
				space = 20;
				printTableHeader(space);
				space = space + 7;
			}
		}

		if (proforma.debitare_obj != null && proforma.debitare_obj?.form) {
			doc.text(String(products_no_proforma + 1), 11, space);
			doc.setFont("Roboto", "bold");
			doc.text(proforma.debitare_obj.name, 18, space);
			doc.setFont("Roboto", "normal");
			doc.text(
				proforma.debitare_obj.cantitate + " " + proforma.debitare_obj.um,
				122,
				space
			);

			let pretDebitare = (proforma.debitare_obj.pret * curs).toFixed(2);
			let valDebitare = (
				pretDebitare * proforma.debitare_obj.cantitate
			).toFixed(2);
			doc.text(pretDebitare + " ron", 170, space, {
				align: "right",
			});
			doc.text(valDebitare + " ron", 199, space, {
				align: "right",
			});
			total_fara_tva = total_fara_tva + Number(valDebitare);

			doc.line(10, space + 3, 200, space + 3);
			space = space + 8;
		}

		if (proforma.transport_obj != null && proforma.transport_obj.form) {
			doc.text(
				String(
					proforma.debitare_obj?.form
						? products_no_proforma + 2
						: products_no_proforma + 1
				),
				11,
				space
			);
			doc.setFont("Roboto", "bold");
			doc.text(proforma.transport_obj.name, 18, space);
			doc.setFont("Roboto", "normal");

			doc.text(
				proforma.transport_obj.cantitate + " " + proforma.transport_obj.um,
				122,
				space,
				{
					align: "left",
				}
			);
			let pretTransport = (proforma.transport_obj.pret * curs).toFixed(2);
			let valTransport = (
				pretTransport * proforma.transport_obj.cantitate
			).toFixed(2);
			doc.text(pretTransport + " ron", 170, space, {
				align: "right",
			});
			doc.text(valTransport + " ron", 199, space, {
				align: "right",
			});
			total_fara_tva = total_fara_tva + Number(valTransport);
		} else if (proforma.transport_obj != null && proforma.transport_obj.included) {
			doc.text(
				String(
					proforma.debitare_obj?.form
						? products_no_proforma + 2
						: products_no_proforma + 1
				),
				11,
				space
			);
			doc.setFont("Roboto", "bold");
			doc.text("Transport inclus", 18, space);
		} else {
			doc.text(
				String(
					proforma.debitare_obj?.form
						? products_no_proforma + 2
						: products_no_proforma + 1
				),
				11,
				space
			);
			doc.setFont("Roboto", "bold");
			doc.text("Nu include transport", 18, space);
		}

		doc.line(10, space + 5, 200, space + 5);
		space = space + 10;

		doc.text("Total fara TVA", 170, space + 2, {
			align: "right",
		});
		doc.text(total_fara_tva.toFixed(2) + " ron", 199, space + 2, {
			align: "right",
		});
		doc.text("TVA", 170, space + 7, {
			align: "right",
		});
		doc.text((total_fara_tva * vatRate).toFixed(2) + " ron", 199, space + 7, {
			align: "right",
		});
		doc.text("TOTAL", 170, space + 12, {
			align: "right",
		});
		doc.text(
			(total_fara_tva + total_fara_tva * vatRate).toFixed(2) + " ron",
			199,
			space + 12,
			{
				align: "right",
			}
		);

		doc.setFont("Roboto", "bold");
		if (proforma.t_livrare) {
			doc.text("Termen livrare: " + proforma.t_livrare, 12, space + 2);
		}
		if (proforma.valid) {
			let validDisplay = proforma.valid.toString().includes('zile')
				? proforma.valid.replace(' zile', '')
				: proforma.valid;
			doc.text("Termen de plata: " + validDisplay + " zile", 12, space + 7);
		}
		doc.line(10, space + 18, 200, space + 18);

		space = space + 22;

		if (proforma.procent_proforma < 100) {
			doc.text(
				`Total de plata in avans: ${proforma.procent_proforma}%`,
				12,
				space + 2
			);
			let proforma_fara_tva =
				(total_fara_tva * proforma.procent_proforma) / 100;
			// doc.setFont("Roboto", "bold");;
			doc.text("Total fara TVA", 170, space + 2, {
				align: "right",
			});
			doc.text(proforma_fara_tva.toFixed(2) + " ron", 199, space + 2, {
				align: "right",
			});
			doc.text("TVA", 170, space + 7, {
				align: "right",
			});
			doc.text(
				(proforma_fara_tva * vatRate).toFixed(2) + " ron",
				199,
				space + 7,
				{
					align: "right",
				}
			);
			doc.text("TOTAL", 170, space + 12, {
				align: "right",
			});
			doc.text(
				(proforma_fara_tva + proforma_fara_tva * vatRate).toFixed(2) + " ron",
				199,
				space + 12,
				{
					align: "right",
				}
			);
		}

        // Return document
        resolve(doc)
    }
      catch(err) {
        console.error(err)
        router.push({
          query: M.toast({
            html: "Eroare la generare pdf!",
            classes: "red",
          }),
        });
      }
    });
  }
};